import { render, staticRenderFns } from "./CreateOrderUpload.vue?vue&type=template&id=2c1b58b9&"
import script from "./CreateOrderUpload.vue?vue&type=script&lang=js&"
export * from "./CreateOrderUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports